import { render, staticRenderFns } from "./PurchaseDocumentContainsFilter.vue?vue&type=template&id=2a3a1d20"
import script from "./PurchaseDocumentContainsFilter.vue?vue&type=script&lang=ts"
export * from "./PurchaseDocumentContainsFilter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a3a1d20')) {
      api.createRecord('2a3a1d20', component.options)
    } else {
      api.reload('2a3a1d20', component.options)
    }
    module.hot.accept("./PurchaseDocumentContainsFilter.vue?vue&type=template&id=2a3a1d20", function () {
      api.rerender('2a3a1d20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/purchases/PurchaseDocumentContainsFilter.vue"
export default component.exports